
import React from "react";
import {
  Box, Flex, Heading, Badge, Icon, Center, Button,
  Table, Thead, Tbody, Tr, Th, Td, TableContainer,
  HStack,
} from "@chakra-ui/react";
import { FiPackage, FiEye } from "react-icons/fi";

export function CoolerBreakdown({ scoreBreakdown,onViewCoolerImage,loadingCoolerImage }) {
  const cooler = scoreBreakdown?.cooler;

  return (
    <Box
      bg="white" borderRadius="xl" border="1px solid"
      borderColor="gray.200" boxShadow="lg" p={6}
    >
      <Flex align="center" justify="space-between" mb={4}>
        <Flex align="center">
          <Icon as={FiPackage} color="red.600" boxSize={6} mr={3} />
          <Heading size="md" color="gray.800" fontWeight="semibold">
            Cooler  Breakdown
          </Heading>
        </Flex>
        <HStack spacing={3} align="center">
        <Badge colorScheme="green" fontSize="lg" variant="solid" px={4} py={2}>
          Total Manual Cooler Score: {scoreBreakdown?.cooler?.manualScore ? `${ scoreBreakdown.cooler.manualScore} out of ${scoreBreakdown?.cooler?.maxScore}`:` 0 out of ${scoreBreakdown?.cooler?.maxscore}`} 
        </Badge>
        <Badge colorScheme="red" fontSize="lg" variant="solid" px={4} py={2}>
           Total AI Cooler Score: {scoreBreakdown?.cooler?.coolerScore ? `${scoreBreakdown.cooler.coolerScore} out of ${scoreBreakdown?.cooler?.maxScore}` : `0 out of ${scoreBreakdown?.cooler?.maxScore}`}
        </Badge>
        </HStack>
      </Flex>

       {/* Cooler Visibility Section */}
      <Box mt={8}  borderColor="gray.200" >
        <Flex align="center" mb={4} mt={2}>
          <Icon as={FiEye} color="red.600" boxSize={5} mr={3} />
          <Heading size="md" color="gray.800" fontWeight="semibold">
            Cooler Visibility
          </Heading>
        </Flex>

        {cooler?.coolerPosition || cooler?.planogram ? (
          <TableContainer>
            <Table variant="simple">
              <Thead bg="red.50">
                <Tr>
                  <Th color="red.700" fontWeight="bold" w="35%">Metric Name</Th>
                  <Th color="red.700" fontWeight="bold" w="20%" textAlign="center">Manual Value</Th>
                  <Th color="red.700" fontWeight="bold" w="20%" textAlign="center"> Ai Value</Th>
                  <Th color="red.700" fontWeight="bold" w="25%" textAlign="center">Action</Th>
                  <Th color="red.700" fontWeight="bold" w="20%" textAlign="center">Points</Th>

                </Tr>
              </Thead>
              <Tbody>
                  {cooler.coolerPosition && (
                    <Tr>
                      <Td fontWeight="medium">{cooler.coolerPosition.metricName}</Td>
                      <Td fontWeight="medium"  textAlign="center">{cooler.manualPosition?.value}</Td>
                      <Td fontWeight="medium"  textAlign="center">{cooler.coolerPosition.value}</Td>
                      <Td textAlign="center">
                        <Button
                          size="sm"
                          colorScheme="red"
                          variant="outline"
                          leftIcon={<FiEye />}
                          isDisabled={!cooler.coolerPosition.fileName}
                          isLoading={loadingCoolerImage}
                          onClick={() => onViewCoolerImage(cooler.coolerPosition.fileName)}
                        >
                          View
                        </Button>
                      </Td>
                      <Td textAlign="center" color="green.600" fontWeight="bold">
                        {cooler.coolerPosition.points}
                      </Td>
                    </Tr>
                  )}
                  {cooler.planogram && (
                    <Tr>
                      <Td fontWeight="medium">{cooler.planogram.metricName}</Td>
                      <Td fontWeight="medium"  textAlign="center">{cooler.manualPlanogram?.value}</Td>
                      <Td fontStyle="medium"   textAlign="center">{cooler.planogram.value}</Td>

                      <Td textAlign="center">
                        <Button
                          size="sm"
                          colorScheme="red"
                          variant="outline"
                          leftIcon={<FiEye />}
                          isDisabled={!cooler.planogram.fileName}
                          isLoading={loadingCoolerImage}
                          onClick={() => onViewCoolerImage(cooler.planogram.fileName)}
                        >
                          View
                        </Button>
                      </Td>
                      <Td textAlign="center" color="green.600" fontWeight="bold">
                        {cooler.planogram.points}
                      </Td>
                    </Tr>
                  )}
              </Tbody>
            </Table>
          </TableContainer>
        ) : (
          <Center h="150px" color="gray.500">No visibility data available</Center>
        )}
      </Box>

      <Box mt={8}  borderColor="gray.200" >
        <Flex align="center" mb={4} mt={2}>
          <Icon as={FiEye} color="red.600" boxSize={5} mr={3} />
          <Heading size="md" color="gray.800" fontWeight="semibold">
            Cooler Shelf BreakDown
          </Heading>
        </Flex>

      {cooler?.shelfWiseCounts?.length > 0 ? (
        <TableContainer>
          <Table variant="simple">
            <Thead bg="red.50">
              <Tr>
                <Th color="red.700" fontWeight="bold" w="30%">Shelf Number</Th>
                  <Th color="red.700" fontWeight="bold" w="30%">Manual Status</Th>
                  <Th color="red.700" fontWeight="bold" w="30%"> Ai Status</Th>
                  <Th color="red.700" fontWeight="bold" w="40%" textAlign="center">Actual Counts </Th>
                  <Th color="red.700" fontWeight="bold" w="40%" textAlign="center">
                  Product Percentage
                </Th>
                <Th color="red.700" fontWeight="bold" w="10%" textAlign="center" pr={14}>Points</Th>
              </Tr>
            </Thead>
            <Tbody>
              {cooler.shelfWiseCounts.map((shelf, idx) => (
                <Tr key={idx}>
                  <Td fontWeight="medium">{shelf.shelfNumber}</Td>
                  <Td>
                    <Badge colorScheme={shelf.manualStatus?.toUpperCase()==="PURE"?"green":"red"}
                      variant="solid"
                      px={3} py={1}
                      borderRadius="full"
                      fontWeight="bold"
                  >
                   {shelf.manualStatus}
                   </Badge>
                  </Td>
                  <Td>
                  <Badge colorScheme={shelf.status?.toUpperCase()==="PURE"?"green":"red"}
                  variant="solid"
                  px={3} py={1}
                  borderRadius="full"
                  fontWeight="bold"
                  >
                   {shelf.status}
                   </Badge>
                  </Td>
                  <Td textAlign="center" color="green.600" fontWeight="bold">
                    {shelf.productCount}
                  </Td>
                  <Td textAlign="center" color="green.600" fontWeight="bold">
                    {shelf.result}
                  </Td>
                  <Td>{shelf.points}</Td>
                  
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      ) : (
        <Center h="200px" color="gray.500">No cooler Shelf data available</Center>
      )}
    </Box>
     
    </Box>
  );
}
